import React from 'react';
import PropTypes from 'prop-types';
import { Paper } from 'material-ui';
import Subheader from 'material-ui/Subheader';
import { connect } from 'react-redux';
import Error from '../../../components/common/Error/Error';
import Loading from '../../../components/common/Loading/Loading';
import { fetchApp } from '../../../store/apps/actions';
import style from '../../../styles/styles';
import styles from './EditMediaTypePage.css';
import MediaTypeForm from '../../../components/media/MediaType/MediaTypeForm/MediaTypeForm';
import { putMediaType, fetchMediaType } from '../../../store/mediatypes/actions';
import { MEDIA_TYPE_PAGE } from '../../../constants/routes';

export class EditMediaTypePage extends React.Component {

    static propTypes = {
        app: PropTypes.object,
    };

    static defaultProps = {};

    componentWillMount() {
        this.fetchApplication();
        this.fetchMediaType();
    }

    componentWillUpdate(nextProps) {
        if (this.props.sending && !nextProps.sending && nextProps.mediaType) {
            let url = MEDIA_TYPE_PAGE
                .replace(':appId', this.props.app.id)
                .replace(':mediaTypeId', nextProps.mediaType.id);
            this.props.history.push(url);
        }
    }

    // Fetch

    fetchMediaType(appId = null, mediaTypeId = null) {
        if (this.props.match) {
            const app = appId || this.props.match.params.appId;
            const mediaType = mediaTypeId || this.props.match.params.mediaTypeId;

            if (app && mediaType) {
                this.props.fetchMediaType(app, mediaType);
            }
        }
    }

    fetchApplication(appId = null) {
        if (this.props.match) {
            const id = appId || this.props.match.params.appId;

            if (id) {
                this.props.fetchApp(id);
            }
        }
    }

    // Actions

    handleFormSubmit = async (formProps) => {
        await this.props.putMediaType(this.props.app.id, formProps);
    };

    // Render

    render() {
        if (this.props.error) {
            return (
                <Error
                    title="Error"
                    subtitle="Could not load data"
                    paper={true}
                />
            );
        } else if (this.props.loading || !this.props.app || !this.props.mediaType) {
            return <Loading paper={false} />;
        } else {
            return (
                <div>
                    <h3 style={style.navigation}>Media Type / Edit - {this.props.app.name}</h3>
                    <div className="row">
                        <div style={style.col} className="col-xs-12 col-sm-12 col-md-12">
                            <Paper style={styles.editBox}>
                                <Subheader style={style.subHeader}>{this.props.mediaType.name}</Subheader>

                                <div style={style.paper}>
                                    <MediaTypeForm
                                        onSubmit={this.handleFormSubmit}
                                        submitting={this.props.sending}
                                        initialValues={this.props.initialValues}
                                    />
                                </div>
                                <div style={style.clear} />
                            </Paper>
                        </div>
                    </div>
                </div>
            );
        }
    }
}

function mapStateToProps(state, ownProps) {
    let props = {
        loading: state.apps.pending || state.mediaTypes.pending,
        error: state.apps.error,
        mediaType: state.mediaTypes.currentType,
        app: state.apps.currentApplication,
        sending: state.mediaTypes.sending,
    };

    if (state.mediaTypes.currentType) {
        props.initialValues = state.mediaTypes.currentType;
    }

    return props;
}

export default connect(mapStateToProps, {
    putMediaType,
    fetchApp,
    fetchMediaType,
})(EditMediaTypePage);



// WEBPACK FOOTER //
// src/containers/mediatypes/EditMediaTypePage/EditMediaTypePage.js